/**
 * SearchFocusHook - Handles focusing on search input when triggered by LiveView events
 */
const SearchFocusHook = {
  mounted() {
    this.focusTimer = null;

    // Listen for the focus event from LiveView
    this.handleEvent("focus-search-input", () => {
      if (this.focusTimer !== null) {
        clearTimeout(this.focusTimer);
      }

      this.focusTimer = setTimeout(() => {
        this.focusTimer = null;

        const searchInput = document.getElementById("search-input");
        if (searchInput) {
          searchInput.focus();
          searchInput.select();
        }
      }, 100); // Small delay to ensure the input is rendered
    });
  },

  destroyed() {
    if (this.focusTimer !== null) {
      clearTimeout(this.focusTimer);
      this.focusTimer = null;
    }
  }
};

export default SearchFocusHook;
